import 'slick-carousel';

$(window).on('load', function () {
    if ($('.slider').length > 0) {
        $('.slider').slick({
            adaptiveHeight: true, //make the height of the slider change to the height of the image
            autoplay: true,
            arrows: true, // left and right arrow to navigate throug the slider
            dots: false, // navigation dots
            fade: false, // fade instead of slide,
            infinite: true, // make the slider infinite scrolling
        });
    }
});